import React, { useState, useContext, useEffect, useReducer } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card } from "react-bootstrap";
import { Formik, Form } from "formik";
import * as yup from "yup";
import moduleConfig from "./moduleConfig";
import { Store as toast } from "react-notifications-component";
import { updateInitialState, updateReducer } from "./reducers/updateReducer";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import axios from "../../../config/axios";
import { toastNotification } from "../../../config/toastNotification";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import { isEmpty } from "../../../helpers/CommonHelper";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import CMSFormInput from "../../UI/forms/CMSFormInput";
import CMSFormDate from "../../UI/forms/CMSFormDate";
import CMSFormSelect from "../../UI/forms/CMSFormSelect";
import CMSFormRichText from "../../UI/forms/CMSFormRichText";

const PollUpdate = () => {
  const [updateState, updateDispatch] = useReducer(
    updateReducer,
    updateInitialState
  );
  const [formInitialValues, setFormInitialValues] = useState({});
  const [activities, setActivities] = useState([])

  const { setBreadcrumb } = useContext(BreadcrumbContext);
  let { id } = useParams();
  let navigate = useNavigate();

  let breadcrumbs = {
    listing: {
      label: moduleConfig.title,
      url: `/${moduleConfig.url}`,
    },
    details: {
      label: "Details",
      url: `/${moduleConfig.url}/${id}`,
    },
    update: {
      label: "Update",
    },
  };

  const onSubmit = async (data) => {
    //console.log(data);

    updateDispatch({
      type: "FORM_SUBMISSION_REQUEST",
    });

    try {
      const res = await axios.post(`${moduleConfig.url}/${id}`, data); //
      updateDispatch({
        type: "FORM_SUBMISSION_SUCCESS",
        payload: res.data,
      });
      navigate(`/${moduleConfig.url}`);
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `${moduleConfig.singleItemTitle} updated successfully.`,
        type: "success",
      });
    } catch (error) {
      //console.log(error.message);
      const status = error.response ? error.response.status : 500;
      const errorMessage =
        status === 400 ? error.response.data.errorMessage : error.message;
      console.log(errorMessage);

      updateDispatch({
        type: "FORM_SUBMISSION_FAILURE",
        payload: errorMessage,
      });
      setTimeout(() => {
        updateDispatch({
          type: "FORM_INITIAL_STATE",
        });
      }, 5000);
    }
  };

  const loadItem = async () => {
    if (id) {
      updateDispatch({
        type: "FETCH_REQUEST",
      });

      try {
        const res = await axios.get(`${moduleConfig.url}/${id}`); //
        updateDispatch({
          type: "FETCH_SUCCESS",
          payload: res.data,
        });
      } catch (error) {
        updateDispatch({
          type: "FETCH_FAILURE",
          payload: error,
        });
      }
    }
  };
  const loadActivities = async () => {
    try {
      const res = await axios.get(`${moduleConfig.url}/get-activities-list`); //
      setActivities(res.data.activities)
    } catch (error) {
      console.log("error in get activities")
    }
  };
  useEffect(() => {
    loadActivities();
    loadItem();
    setBreadcrumb([
      breadcrumbs.listing,
      breadcrumbs.details,
      breadcrumbs.update,
    ]);
  }, [id]);
  useEffect(() => {
    if (updateState.data.item && updateState.data.item._id) {
      updateState.data.item.activityId = updateState.data.item.activityId ? updateState.data.item.activityId : ''

      setFormInitialValues(updateState.data.item);
    }
  }, [updateState.data]);

  return (
    <DashboardLayout>
      {Object.keys(formInitialValues).length <= 0 && updateState.isLoading && (
        <ContainerLoading />
      )}

      {updateState.error && updateState.status === "fetchFailed" ? (
        <BlockErrorMessage error={updateState.error} />
      ) : (
        <>
          <ModuleHeader
            moduleTitle={`Update ${moduleConfig.singleItemTitle}`}
            moduleUrl={moduleConfig.url}
          ></ModuleHeader>

          {Object.keys(formInitialValues).length > 0 &&
            updateState.data &&
            updateState.data.item &&
            !isEmpty(updateState.data.item._id) && (
              <section className="content">
                <Card>
                  <Card.Body>
                    {updateState.isLoading && (
                      <div class="overlay position-absolute containerLoading">
                        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                      </div>
                    )}
                    <Formik
                      initialValues={formInitialValues}
                      validationSchema={yup.object({
                        title: yup.string().required("Required").max(100),
                        description: yup.string(),
                        sortOrder: yup.number(),
                        target: yup.string().required("Required"),
                        status: yup.string().required("Required"),
                        activityId: yup.string(),
                      })}
                      enableReinitialize={true}
                      validateOnChange={true}
                      validateOnBlur={true}
                      onSubmit={async (values) => {
                        onSubmit(values);
                      }}
                    >
                      {(form) => (
                        <Form onSubmit={form.handleSubmit}>
                          {updateState.error && (
                            <FormErrorMessage error={updateState.error} />
                          )}

                          <CMSFormInput
                            name="title"
                            label="Title"
                            form={form}
                            required={true}
                          />

                          <CMSFormSelect
                            name="target"
                            label="Target"
                            required={true}
                            form={form}
                            options={[
                              { value: "All-Members", label: "All-Members" },
                              {
                                value: "Selected-Members",
                                label: "Selected-Members",
                              },
                              {
                                value: "Selected-Circles",
                                label: "Selected-Circles",
                              },
                              {
                                value: "Attach-to-Activity",
                                label: "Attach to Activity",
                              },
                            ]}
                          />

                          {(form.values["target"] === "Attach-to-Activity") &&
                            <CMSFormSelect
                              name="activityId"
                              label="Attach to Activity"
                              required={false}
                              form={form}
                              options={activities}
                            />
                          }

                          <CMSFormInput
                            name="sortOrder"
                            label="Sort Order"
                            required={false}
                            form={form}
                          />

                          {/* <CMSFormSelect
                            name="activityId"
                            label="Attach to Activity"
                            required={false}
                            form={form}
                            options={activities}
                          /> */}

                          <CMSFormRichText
                            name="description"
                            label="Description"
                            form={form}
                          />

                          <CMSFormSelect
                            name="resultType"
                            label="Show Results On"
                            required={true}
                            form={form}
                            options={[
                              { value: "After Submission", label: "Show After Submission" },
                              { value: "After Announced", label: "Show After Announced" },
                              // { value: "On Authorized Screen", label: "Show On Authorized Screen" },
                            ]}
                          />

                          <CMSFormSelect
                            name="status"
                            label="Status"
                            required={true}
                            form={form}
                            options={[
                              { value: "disabled", label: "Disabled" },
                              { value: "notStarted", label: "Not Started" },
                              { value: "begun", label: "Begun" },
                              { value: "finished", label: "Finished" },
                              { value: "announced", label: "Results Announced" },
                              { value: "archived", label: "Archived" },
                            ]}
                          />

                          <button className="btn btn-primary" type="submit">
                            Submit
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </Card.Body>
                </Card>
              </section>
            )}
        </>
      )}
    </DashboardLayout>
  );
};
export default PollUpdate;
